import React from 'react';
import { Html } from '@react-three/drei';
import { circleFrom3Points } from '../../utils/geometry';

/**
 * Bogen-Mittelpunkte anzeigen.
 * Visualisiert den Mittelpunkt und Radius aller Bögen im Grundriss.
 */
export function ArcCenters({ arcs, points }) {
  if (!arcs || arcs.length === 0) return null;

  return (
    <group name="arc-centers">
      {arcs.map(arc => {
        // Punkte des Bogens holen
        const startPoint = points.find(p => p.id === arc.startPointId);
        const throughPoint = points.find(p => p.id === arc.throughPointId);
        const endPoint = points.find(p => p.id === arc.endPointId);

        if (!startPoint || !throughPoint || !endPoint) return null;

        // Kreismittelpunkt berechnen
        const circle = circleFrom3Points(startPoint, throughPoint, endPoint);
        if (!circle) return null; // Kollineare Punkte

        const { cx, cy, radius } = circle;

        return (
          <group key={`arc-center-${arc.id}`}>
            {/* Mittelpunkt-Marker (Kreuz mit Kreis) */}
            <mesh position={[cx, cy, 3]}>
              <ringGeometry args={[40, 60, 24]} />
              <meshBasicMaterial color="#f59e0b" transparent opacity={0.7} />
            </mesh>

            {/* Kreuz im Mittelpunkt */}
            <line>
              <bufferGeometry>
                <bufferAttribute
                  attach="attributes-position"
                  count={4}
                  array={new Float32Array([
                    cx - 80, cy, 4,
                    cx + 80, cy, 4,
                    cx, cy - 80, 4,
                    cx, cy + 80, 4,
                  ])}
                  itemSize={3}
                />
              </bufferGeometry>
              <lineBasicMaterial color="#f59e0b" linewidth={2} />
            </line>

            {/* Radius-Linie zum Through-Point (gestrichelt) */}
            <line>
              <bufferGeometry>
                <bufferAttribute
                  attach="attributes-position"
                  count={2}
                  array={new Float32Array([
                    cx, cy, 2,
                    throughPoint.x, throughPoint.y, 2,
                  ])}
                  itemSize={3}
                />
              </bufferGeometry>
              <lineBasicMaterial color="#f59e0b" linewidth={1} transparent opacity={0.4} />
            </line>

            {/* Radius-Beschriftung */}
            <Html
              position={[cx + 120, cy + 120, 10]}
              style={{ pointerEvents: 'none', userSelect: 'none' }}
            >
              <div className="bg-amber-500/90 text-white text-xs px-1.5 py-0.5 rounded shadow-lg font-mono whitespace-nowrap">
                r = {(radius / 1000).toFixed(2)} m
              </div>
            </Html>
          </group>
        );
      })}
    </group>
  );
}

export default ArcCenters;
